import { useState } from "react";

import Modal from "../../../../../components/common/Modal";
import NotesForm from "./NotesForm";

const Notes = ({ data, setData }) => {
  const [showForm, setShowForm] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <div className="bg-gray-50 px-6 py-5 grid grid-cols-3">
      <dt className="col-span-2">
        <p className="text-gray-400 text-sm">Notes</p>
      </dt>
      <dd className="col-span-1 text-blue-400 text-sm cursor-pointer">
        <span className="float-right" onClick={() => setShowForm(true)}>
          Edit
        </span>
      </dd>
      <dt className="col-span-3 notes-container">
        {data.notes && (
          <div
            className="text-gray-400 text-sm p-3"
            dangerouslySetInnerHTML={{ __html: data.notes }}
          ></div>
        )}
        {!data.notes && (
          <span className="text-sm text-gray-500">Not available</span>
        )}
      </dt>
      <Modal
        size="lg"
        title="Notes"
        isOpen={showForm}
        isLoading={isLoading}
        onClose={() => setShowForm(false)}
        borderTop
      >
        <NotesForm
          data={data}
          isLoading={isLoading}
          setData={setData}
          setLoading={setIsLoading}
          setShow={setShowForm}
        />
      </Modal>
    </div>
  );
};

export default Notes;
